import React from "react";
import { Identifiable, Project } from "@planzone/dto";

import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { Input } from "./input";
import { Search } from "./search";
import { Zones } from "./zones";
import styles from "./styles.scss";

function ProjectsSelection({ placeholder = "", zone, onSelectProject }: Props) {
  const [search, setSearch] = React.useState("");
  const [selectedProject, setSelectedProject] =
    React.useState<Identifiable<Project> | null>(null);

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.list}>
      {({ isOpen, select }) => ({
        input: (
          <Input
            project={selectedProject || undefined}
            placeholder={placeholder}
            isOpen={isOpen}
          />
        ),
        list: (
          <div className={styles.projectsSelection}>
            <div className={styles.search}>
              <Search search={search} setSearch={setSearch} />
            </div>
            <Zones
              search={search}
              zone={zone}
              selectedProject={selectedProject}
              onSelectProject={(project) => {
                setSelectedProject(project);
                onSelectProject?.(project);
                select(null);
              }}
              isOpen
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ProjectsSelection };
